import RubyInstall from "../../../../contents/docs/integrate/_snippets/install-ruby.mdx";
import RubySendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ruby.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import RubyFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ruby.mdx";
import LocalEvaluationIntro from "../../../../contents/docs/feature-flags/snippets/local-evaluation-intro.mdx";
import * as React from 'react';
export default {
  RubyInstall,
  RubySendEvents,
  FeatureFlagsLibsIntro,
  RubyFeatureFlagsCode,
  LocalEvaluationIntro,
  React
};